import { Analytika, AnalytikaEvent } from '@analytika/analytika-web';
import UAParser from 'ua-parser-js';
import store from '../../redux/store';
import { getAnalytikaScreenName, getSessionParams } from './reporterAnalytika';
import { ANALYTIKA_EVENT_SOURCE, ANALYTIKA_V2_ENV } from '../constants';
import { AppState } from '../../types/store';
import { ANALYTIKA_EVENTS_V2, ANALYTIKA_SCREENS } from './enums';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

Analytika.init(ANALYTIKA_V2_ENV, false, {}, 10, 10);

const { device } = UAParser();

// Note: browser.version, device.vendor, device.model are not present in the payload but can be helpful
const publishAV2Event = (eventData: AnalytikaEvent, screen?: ANALYTIKA_SCREENS): void => {
  const sessionParams = getSessionParams();
  // TODO: cover store.js with proper typescript

  const appState: any = store.getState();

  const {
    user: {
      userData: { userId, name, email, phone, city }
    }
  } = appState as AppState;

  Analytika.publish({
    device_type: device.type ?? 'Desktop',
    event_source: ANALYTIKA_EVENT_SOURCE,
    session_id: sessionParams?.sessionId,
    event_trigger_time: new Date().getTime(),
    screen_name: screen || getAnalytikaScreenName(window.location.pathname),
    user_id: userId,
    merchant_id: userId,
    user_name: name,
    user_email: email,
    user_phone: phone,
    city: city?.name,
    ...eventData
  });
};

export const AnalytikaV2PageReporter = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    pathname &&
      publishAV2Event({
        event_name: ANALYTIKA_EVENTS_V2.EXPR_VIEW_SCREEN,
        event_version: 2,
        screen_name: getAnalytikaScreenName(pathname)
      });
  }, [pathname]);
  return null;
};

export default publishAV2Event;
